import React, { Fragment, Component } from 'react';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Navbar from './Navbar';
import axios from '../../axios/axios';
import Snackbar, { openSnackbar } from '../utils/Snackbar';
import { connect } from 'react-redux';
import * as actionTypes from '../../store/action';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import CircularProgress from '@material-ui/core/CircularProgress';


function Transition(props) {
    return <Slide direction="up" {...props} />;
}

const styles = theme => ({
    root: {

    },
    container: {
        width: '90%',
        margin: '10px auto',
        textAlign: 'center'
    },
    line1: {
        margin: '10px 0',
        fontSize: '60px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '35px'
        }
    },
    button: {
        margin: '10px 0',
        color: '#FFFFFF',
        backgroundColor: '#e67300',
        '&:hover': {
            color: '#FFFFFF',
            backgroundColor: '#ff9933'
        }
    },
    header: {
        backgroundColor: '#e67300',
        borderRadius: '5px',
        color: '#FFFFFF'
    },
    subHeader: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.background.default,
        },
    },
    heading: {
        margin: '10px 0',
        fontSize: '25px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '20px'
        }
    },
    subHeading: {
        margin: '10px 0',
        fontSize: '22px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '18px'
        }
    },
    dialogContent: {
        margin: '5px',
        textAlign: 'center'
    },
    deleteBT: {
        margin: '10px 0',
        color: '#FFFFFF',
        backgroundColor: 'red'
    },
    progress: {
        margin: theme.spacing.unit * 2,
    },
});

class ManageBlog extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            blog: null,
            blogs: [],
            hasMore: true,
            limit: 9
        }
    }

    componentDidMount() {
        if (this.props.token === "") {
            this.props.history.push("/admin");
            return;
        }
        this.fetchBlogs();
    }

    fetchBlogs = () => {
        axios.get('blog/fetch', {
            params: {
                offset: this.state.blogs.length,
                limit: this.state.limit
            }
        }).then(result => {
            if (result.status === 200) {
                if (result.data.success) {
                    this.setState(prevState => ({
                        blogs: [...prevState.blogs, ...result.data.blogs]
                    }), () => {
                        this.setState({
                            loading: false
                        });
                        if (result.data.blogs.length === 0 || this.state.blogs.length < this.state.limit) {
                            this.setState({
                                hasMore: false
                            });
                        }
                    });
                } else {
                    openSnackbar({ message: result.data.msg, variant: "error" });
                }
            } else {
                openSnackbar({ message: "Something went wrong", variant: "error" });
            }
        }).catch(error => {
            openSnackbar({ message: "Something went wrong", variant: "error" });
        });
    }

    deleteBlog = (id) => {
        axios.delete(`blog/?id=${id}`, {
            headers: {
                authorization: `Bearer ${this.props.token}`
            }
        }).then(result => {
            if (result.status === 200) {
                if (result.data.success) {
                    openSnackbar({ message: result.data.msg, variant: "success" });
                    const newList = this.state.blogs.filter(blog => {
                        return blog.id !== id;
                    });

                    this.setState({
                        blogs: newList,
                        open: false
                    });
                } else {
                    openSnackbar({ message: result.data.msg, variant: "error" });
                }
            } else {
                openSnackbar({ message: "Something went wrong", variant: "error" });
            }
        }).catch(error => {
            openSnackbar({ message: "Something went wrong", variant: "error" });
        });
    }

    handleClickOpen = (blog) => {
        this.setState({
            open: true,
            blog: blog
        });
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    render() {
        const { classes } = this.props;
        return (
            <Fragment>
                <Navbar />
                <Snackbar />
                <div className={classes.container}>
                    <Typography variant="h1" className={classes.line1}>Manage Blog</Typography>
                    <Button variant="outlined" color="secondary" className={classes.button}
                        onClick={() => {
                            this.props.history.push("/admin/blogPost");
                        }}>New Blog</Button>
                    <br /><br />
                    <div className={classes.header}>
                        <Grid container>
                            <Grid item xs={3} className={classes.heading}>Date</Grid>
                            <Grid item xs={6} className={classes.heading}>Title</Grid>
                            <Grid item xs={3} className={classes.heading}>Action</Grid>
                        </Grid>
                    </div>
                    {this.state.blogs.map(blog => {
                        return (
                            <div className={classes.subHeader} key={blog.id}>
                                <Grid container>
                                    <Grid item xs={3} className={classes.subHeading}>{blog.createdAt}</Grid>
                                    <Grid item xs={6} className={classes.subHeading}>{blog.title}</Grid>
                                    <Grid item xs={3} className={classes.subHeading}>
                                        <Typography variant="inherit"><span style={{ color: '#e67300', fontWeight: '400', cursor: 'pointer' }} onClick={() => {
                                            this.props.saveBlog(blog);
                                            this.props.history.push("/admin/updateBlog");
                                        }}>Update</span></Typography>
                                        <Typography variant="inherit"><span style={{ color: 'red', fontWeight: '400', cursor: 'pointer' }} onClick={() => {
                                            this.handleClickOpen(blog);
                                        }}>Delete</span></Typography>
                                    </Grid>
                                </Grid>
                            </div>
                        );
                    })}
                    {this.state.loading ? (<CircularProgress className={classes.progress} color="secondary" />) : null}
                    <br />
                    {this.state.hasMore ? (<Button variant="outlined" color="secondary" className={classes.loadMore}
                        onClick={() => {
                            this.fetchBlogs();
                        }}>Load More</Button>) : null}

                    {this.state.contact !== null ?
                        <Dialog
                            open={this.state.open}
                            TransitionComponent={Transition}
                            keepMounted
                            onClose={this.handleClose}
                            aria-labelledby="alert-dialog-slide-title"
                            aria-describedby="alert-dialog-slide-description"
                        >
                            <DialogTitle id="scroll-dialog-title">Delete Blog</DialogTitle>
                            <DialogContent className={classes.dialogContent}>

                                <Typography variant="inherit">Are you sure?</Typography>

                                <Button variant="outlined" color="secondary" className={classes.deleteBT}
                                    onClick={() => {
                                        this.deleteBlog(this.state.blog.id);
                                    }}>Delete</Button>

                            </DialogContent>
                            <DialogActions>
                                <Button onClick={this.handleClose} color="primary">
                                    Cancel</Button>
                            </DialogActions>
                        </Dialog>
                        : null}
                </div>
            </Fragment>
        );
    }
}

ManageBlog.propTypes = {
    classes: PropTypes.object.isRequired
}

const mapStateToProps = state => {
    return {
        token: state.login.token,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        saveBlog: (blog) => dispatch({ type: actionTypes.BLOG_DATA, blogData: blog })
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ManageBlog));